import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Import mobile page components
import MobileNav from './MobileNav/page';
import MobileMe from './Me/page';
import MobileEducation from './Education/page';
import MobileHobbies from './Hobbies/page';
import MobileExperience from './Experience/page';
import MobileSkills from './Skills/page';
import MobileProjects from './Projects/page';
import MobileResearch from './Research/page';
import MobileAccolades from './Accolades/page';
import MobileBlogs from './Blog/page';
import MobileActivities from './Activities/page';
import PCRecommendModal from './PCRecommendModal/page';

const MobileRouter = ({ isDarkMode, toggleTheme }) => {
    return (
        <div className="mobile-layout">
            <PCRecommendModal />
            <MobileNav isDarkMode={isDarkMode} toggleTheme={toggleTheme} />

            <div className="mobile-content">
                <Routes>
                    <Route path="/" element={<Navigate to="/about" replace />} />
                    <Route path="/about" element={<MobileMe isDarkMode={isDarkMode} />} />
                    <Route path="/education" element={<MobileEducation isDarkMode={isDarkMode} />} />
                    <Route path="/hobbies" element={<MobileHobbies isDarkMode={isDarkMode} />} />
                    <Route path="/experience" element={<MobileExperience isDarkMode={isDarkMode} />} />
                    <Route path="/skills" element={<MobileSkills isDarkMode={isDarkMode} />} />
                    <Route path="/projects" element={<MobileProjects isDarkMode={isDarkMode} />} />
                    <Route path="/research" element={<MobileResearch isDarkMode={isDarkMode} />} />
                    <Route path="/accolades" element={<MobileAccolades isDarkMode={isDarkMode} />} />
                    <Route path="/blogs" element={<MobileBlogs isDarkMode={isDarkMode} />} />
                    <Route path="/activities" element={<MobileActivities isDarkMode={isDarkMode} />} />
                </Routes>
            </div>
        </div>
    );
};

export default MobileRouter;